import { RadialWheel } from './radialwheel';

// QUICK-COMMS radial (owner QoL): hold T -> pick Help / Follow / Base / Danger -> release drops a team
// beacon at your position (main relays it over the ping channel). A RadialWheel subclass, so it inherits
// the first-person movement-cursor selection + release-to-select for free.
export type CommsAction = 'help' | 'follow' | 'base' | 'danger';

export class CommsWheel extends RadialWheel<CommsAction, never> {
  onPick: ((a: CommsAction) => void) | null = null;

  constructor() {
    super({
      segments: [
        { key: 'help', label: 'HELP' },
        { key: 'follow', label: 'FOLLOW' },
        { key: 'base', label: 'BASE' },
        { key: 'danger', label: 'DANGER' },
      ],
      activeSeg: null,
      hubFallbackLabel: 'COMMS',
      onPointerCommit: () => this.commitSelection(),
    });
  }

  // Apply the hovered action + close. Also called on the T-key release (release-to-select).
  commitSelection(): void { this.commit({ onSeg: (a) => { this.onPick?.(a); this.hide(); }, stickySeg: false }); }
}
